import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        path: "dashboard",

        data: { level: "W", access: "dashboard" },
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "password",
        loadChildren: () =>
          import("../main/password/password.module").then(
            (m) => m.PasswordModule,
          ),
      },
      {
        path: "user-management",

        data: { level: "W", access: "users" },
        loadChildren: () =>
          import("../main/user-management/user-management.module").then(
            (m) => m.UserManagementModule,
          ),
      },
      {
        path: "provider-earning-management",

        data: { level: "W", access: "users" },
        loadChildren: () =>
          import("../main/provider-earning-management/provider-earning-management.module").then(
            (m) => m.ProfessionalEarningManagementModule,
          ),
      },

      {
        path: "operator",

        data: { level: "W", access: "operators" },
        loadChildren: () =>
          import("../main/operator/operator.module").then(
            (m) => m.OperatorModule,
          ),
      },

      {
        path: "profile",

        data: { level: "W", access: "passengers" },
        loadChildren: () =>
          import("../main/profile-management/profile-management.module").then(
            (m) => m.ProfileManagementModule,
          ),
      },
      {
        path: "category",

        data: { level: "W", access: "passengers" },
        loadChildren: () =>
          import("../main/category-management/category-management.module").then(
            (m) => m.CategoryManagementModule,
          ),
      },
      {
        path: "payment-management",

        data: { level: "W", access: "invoice" },
        loadChildren: () =>
          import("../main/payment-management/payment-management.module").then(
            (m) => m.PaymentManagementModule,
          ),
      },
      {
        path: "order",

        data: { level: "W", access: "invoice" },
        loadChildren: () =>
          import("../main/order-management/order-management.module").then(
            (m) => m.OrderManagementModule,
          ),
      },

      {
        path: "promo",

        loadChildren: () =>
          import("../main/promo-management/promo-management.module").then(
            (m) => m.PromoManagementModule,
          ),
      },

      {
        path: "booking-management",

        loadChildren: () =>
          import("../main/booking-management/booking-management.module").then(
            (m) => m.BookingManagementModule,
          ),
      },

      {
        path: "menu",

        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/menu-management/merchant-management.module").then(
            (m) => m.MenuManagementModule,
          ),
      },
      {
        path: "merchant",

        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/merchant-management/merchant-management.module").then(
            (m) => m.MerchantManagementModule,
          ),
      },
      {
        path: "map",

        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/map-management/map-management.module").then(
            (m) => m.MapManagementModule,
          ),
      },
      {
        path: "officer-management",

        data: { access: "EO" },
        loadChildren: () =>
          import("../main/officer/officer.module").then((m) => m.OfficerModule),
      },

      {
        path: "provider-management",

        data: { access: "drivers" },
        loadChildren: () =>
          import("./provider-management/driver-management.module").then(
            (m) => m.DriverManagementModule,
          ),
      },
      {
        path: "platform-fee-commission",

        data: { access: "drivers" },
        loadChildren: () =>
          import("./platform-fee-commission/platform-fee-commission.module").then(
            (m) => m.PlatformFeeCommissionModule,
          ),
      },
      {
        path: "stakeholder",

        data: { access: "stakeholders" },
        loadChildren: () =>
          import("../main/stack-holder/shareholder.module").then(
            (m) => m.ShareholderModule,
          ),
      },
      {
        path: "bookings",
        loadChildren: () =>
          import("../main/payout/payout.module").then((m) => m.PayoutModule),
      },
      {
        path: "provider-payout",
        loadChildren: () =>
          import("../main/provider-payout/provider-payout.module").then(
            (m) => m.ProfessionalModule,
          ),
      },
{
  path: 'professional-payout-details/:id',
  loadChildren: () =>
    import('../main/professional-payout-details/professional-payout-details.module').then(
      m => m.ProfessionalPayoutDetailsModule
    )
},


      {
        path: "booking-history",
        loadChildren: () =>
          import("../main/history/history.module").then((m) => m.HistoryModule),
      },

      {
        path: "service-area-management",

        loadChildren: () =>
          import("../main/officer/officer.module").then((m) => m.OfficerModule),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then(
            (m) => m.SettingManagementModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
